import { useState, useEffect, useCallback } from 'react';
import useLocale from '../../../hooks/useLocale';

export const useCountrySelection = () => {
  const { data: locale } = useLocale();
  const [selectedCountry, setSelectedCountry] = useState<string>('');
  const [selectedState, setSelectedState] = useState<string>('');
  const [hasInitialized, setHasInitialized] = useState(false);

  useEffect(() => {
    if (locale?.country && !hasInitialized) {
      setSelectedCountry(locale.country);
      setHasInitialized(true);
    }
  }, [locale?.country, hasInitialized]);

  const handleCountrySelect = useCallback((countryCode: string) => {
    setSelectedCountry(countryCode);
    setSelectedState('');
  }, []);

  const handleStateSelect = useCallback((stateCode: string) => {
    setSelectedState(stateCode);
  }, []);

  return {
    selectedCountry,
    selectedState,
    handleCountrySelect,
    handleStateSelect,
  };
};
